import { useEffect } from "react";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

import { ParceirosFooter } from "@/components/parceiros/ParceirosFooter";
import { EventoHeader } from "@/components/evento/EventoHeader";
import { CTAAnchor } from "@/components/parceiros/cta";
import { useMetaPixel } from "@/hooks/useMetaPixel";
import { trackCompleteRegistration } from "@/lib/meta-pixel";

const EventoObrigado = () => {
  useMetaPixel();

  useEffect(() => {
    document.title = "Aplicação enviada — Allu";

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#FAF8F5";
    document.body.style.color = "#112711";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    trackCompleteRegistration({
      content_name: "Evento Presencial Allu Invest",
      content_category: "evento",
    });

    return () => {
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = "";
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF8F5] text-[#112711] flex flex-col"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <EventoHeader />

      <main className="flex-1 flex items-center">
        <div className="container-narrow py-16 sm:py-24 w-full">
          <div className="max-w-2xl mx-auto text-center">
            <span className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6 bg-[#D1F8E2] ring-8 ring-[#D1F8E2]/40">
              <CheckCircle2 className="w-8 h-8 text-[#112711]" />
            </span>

            <h1
              className="font-bold text-[#112711] text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight"
              style={{ letterSpacing: "-0.02em" }}
            >
              Sua aplicação foi enviada
            </h1>

            <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed max-w-xl mx-auto">
              Nossa equipe vai revisar sua aplicação. Se você for selecionado,
              entraremos em contato pelo telefone cadastrado. Fique atento ao
              seu WhatsApp e telefone.
            </p>

            <div className="mt-12">
              <CTAAnchor href="/evento" variant="outline" size="md">
                <ArrowLeft className="w-4 h-4" />
                Voltar para a página
              </CTAAnchor>
            </div>

            <p className="mt-12 text-xs text-zinc-500">
              Dúvidas? Escreva pra{" "}
              <a
                href="mailto:yago@allugator.com"
                className="text-[#112711] underline underline-offset-4 hover:text-[#1F4A33]"
              >
                yago@allugator.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>

      <ParceirosFooter />
    </div>
  );
};

export default EventoObrigado;
